import React, {useState, useEffect, Fragment, useContext} from "react";
import Layout from "components/sales/layout/layout";
import DivLayout from "../../../../../components/sales/divLayout/divLayout";
import Images from 'assets/images/imageData';
import {toast} from "react-toastify";
import {Button} from "react-bootstrap";

const TranchesReleaseRequest = ({
        match,
        loanAccountRequest,
        loanApplicationByIdRequest,
        loanTranchesRequest,
        loanTranchesResponse = [],
        updateTrancheStatusResponse = [],
        updateTrancheStatusRequest,

    }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRoleId(localStorage.getItem('fusion-role'))
            await loanAccountRequest(match?.params?.id)
            await loanApplicationByIdRequest(match?.params?.id)
            await loanTranchesRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const handleChangeStatus = async (e, trancheId, status) => {
        setIsLoading(true)
        await updateTrancheStatusRequest({status: status, loan_id: match?.params?.id, tranche_id: trancheId})
        setIsLoading(false)
    }


    useEffect(() => {
        if (parseInt(updateTrancheStatusResponse?.status) === 200) {
            toast.success(updateTrancheStatusResponse?.message);
            window.location.reload();
        } else if (parseInt(updateTrancheStatusResponse?.status) !== 200) {
            toast.error(updateTrancheStatusResponse?.message);
        }
    }, [updateTrancheStatusResponse]);


    return (
        <>
            <Layout
                title={"Payment Details"}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <div className="container-v2">
                        {
                            loanTranchesResponse?.data?.TRANCHES && loanTranchesResponse?.data?.TRANCHES.length > 0 &&
                                loanTranchesResponse?.data?.TRANCHES.map((val, i) => {
                                    return (
                                        <>
                                            <div className="panel-card">
                                                <div className="panel-heading">
                                                    {`Tranche ${i + 1}`}
                                                </div>
                                                <div className="panel-body">
                                                    <div className="details-listing">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account to be transferred"}
                                                                    data={
                                                                        val?.amount
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account Number"}
                                                                    data={
                                                                        val?.account_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"IFSC Code"}
                                                                    data={
                                                                        val?.ifsc_code
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Bank Name"}
                                                                    data={
                                                                        val?.bank_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Branch Name"}
                                                                    data={
                                                                        val?.branch_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Mode of Payment"}
                                                                    data={
                                                                        val?.payment_mode
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"UTR Number"}
                                                                    data={
                                                                        val?.utr_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Status"}
                                                                    data={
                                                                        val?.status
                                                                    }
                                                                />
                                                            </div>
                                                            {(parseInt(roleId) === 41 || parseInt(roleId) === 54) && (val?.status === null || val?.status === 'BACK_TO_MODIFICATION' ||
                                                                    val?.status === 'REQUEST_FOR_MODIFICATION') &&
                                                                <>
                                                                    <div className="col-md-12 d-flex mb-3" style={{justifyContent: "flex-end"}}>
                                                                        <button
                                                                            className="btn btn-primary btn-sm"
                                                                            onClick={(e) => {
                                                                                handleChangeStatus(e, val?.tranche_id, 'APPROVAL_PENDING')
                                                                            }}
                                                                        >
                                                                            Release payment request
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                        }
                        {
                            loanTranchesResponse?.data?.HOLD_BACK_TRANCHE && loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.length > 0 &&
                                loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.map((val, i) => {
                                    return (
                                        <>
                                            <div className="panel-card">
                                                <div className="panel-heading">
                                                    {`Hold Back ${i + 1}`}
                                                </div>
                                                <div className="panel-body">
                                                    <div className="details-listing">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account to be transferred"}
                                                                    data={
                                                                        val?.amount
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account Number"}
                                                                    data={
                                                                        val?.account_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"IFSC Code"}
                                                                    data={
                                                                        val?.ifsc_code
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Bank Name"}
                                                                    data={
                                                                        val?.bank_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Branch Name"}
                                                                    data={
                                                                        val?.branch_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Mode of Payment"}
                                                                    data={
                                                                        val?.payment_mode
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"UTR Number"}
                                                                    data={
                                                                        val?.utr_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Status"}
                                                                    data={
                                                                        val?.status
                                                                    }
                                                                />
                                                            </div>
                                                            {(parseInt(roleId) === 41 || parseInt(roleId) === 54) && (val?.status === null || val?.status === 'BACK_TO_MODIFICATION' ||
                                                                    val?.status === 'REQUEST_FOR_MODIFICATION') &&
                                                                <>
                                                                    <div className="col-md-12 d-flex mb-3" style={{justifyContent: "flex-end"}}>
                                                                        <button
                                                                            className="btn btn-primary btn-sm"
                                                                            onClick={(e) => {
                                                                                handleChangeStatus(e, val?.tranche_id, 'APPROVAL_PENDING')
                                                                            }}
                                                                        >
                                                                            Release payment request
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            }

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                        }

                        {
                            loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE && loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.length > 0 &&
                                loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.map((val, i) => {
                                    return (
                                        <>
                                            <div className="panel-card">
                                                <div className="panel-heading">
                                                    {`Fore Closure ${i + 1}`}
                                                </div>
                                                <div className="panel-body">
                                                    <div className="details-listing">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account to be transferred"}
                                                                    data={
                                                                        val?.amount
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Account Number"}
                                                                    data={
                                                                        val?.account_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"IFSC Code"}
                                                                    data={
                                                                        val?.ifsc_code
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Bank Name"}
                                                                    data={
                                                                        val?.bank_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Branch Name"}
                                                                    data={
                                                                        val?.branch_name
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Mode of Payment"}
                                                                    data={
                                                                        val?.payment_mode
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"UTR Number"}
                                                                    data={
                                                                        val?.utr_number
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <DivLayout
                                                                    heading={"Status"}
                                                                    data={
                                                                        val?.status
                                                                    }
                                                                />
                                                            </div>
                                                            {(parseInt(roleId) === 41 || parseInt(roleId) === 54) && (val?.status === null || val?.status === 'BACK_TO_MODIFICATION' ||
                                                                    val?.status === 'REQUEST_FOR_MODIFICATION') &&
                                                                <>
                                                                    <div className="col-md-12 d-flex mb-3" style={{justifyContent: "flex-end"}}>
                                                                        <button
                                                                            className="btn btn-primary btn-sm"
                                                                            onClick={(e) => {
                                                                                handleChangeStatus(e, val?.tranche_id, 'APPROVAL_PENDING')
                                                                            }}
                                                                        >
                                                                            Release payment request
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            }

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                        }
                    </div>
                </div>

                {(loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE && loanTranchesResponse?.data?.FORE_CLOSURE_TRANCHE.length === 0) &&
                    (loanTranchesResponse?.data?.HOLD_BACK_TRANCHE && loanTranchesResponse?.data?.HOLD_BACK_TRANCHE.length === 0) &&
                    (loanTranchesResponse?.data?.TRANCHES && loanTranchesResponse?.data?.TRANCHES.length === 0) &&
                        <img src={Images?.NoData} alt="" width="100%" />
                }


                {/*<div className="col-md-12 mb-2">*/}
                {/*    <center>*/}
                {/*        <Button onClick={handleSubmit}>*/}
                {/*            Submit*/}
                {/*        </Button>*/}
                {/*    </center>*/}
                {/*</div>*/}
            </Layout>
        </>
    );
};

export default TranchesReleaseRequest;
